import React, { useContext, useState } from 'react'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import BigModal from '../../../../components/Modals/BigModal'
import { AlertTitle, TextField } from '@mui/material'
import API from '../../../../services/API'
import { GlobalContext, UserContext } from '../../../../App'
import moment from 'moment'

const Details = ({ incident }) => (
  <>
    <DetailRow
      label="Details"
      value={incident.healthSafetyDetails}
      fullWidthLabel
    />
    <DetailRow
      label="H&S Incident Type"
      value={incident.healthSafetyType && incident.healthSafetyType.join(', ')}
      fullWidthLabel
    />
    <DetailRow
      label="Immediate Action Taken"
      value={incident.healthSafetyImmediateActionTaken}
      fullWidthLabel
    />
    <DetailRow
      label="Event Organiser Notified"
      value={incident.healthSafetyEventOrganiserNotified ? 'Yes' : 'No'}
      fullWidthLabel
    />
    <DetailRow
      label="Additional Notes"
      value={incident.healthSafetyAdditionalNotesForOrganiser}
      fullWidthLabel
    />
  </>
)

const HSIncidentModule = ({ incident, epcrID, setRecord, ePCRStatus }) => {
  const [openReviewPanel, setOpenReviewPanel] = useState(false)
  const [managerNotes, setManagerNotes] = useState('')
  const { user } = useContext(UserContext)
  const { setToast } = useContext(GlobalContext)
  const isHidden = incident.healthSafetyConcernHiddenFromOrganiser
  const isDraft = ePCRStatus === 'Draft'

  const handleSubmission = () => {
    API.put(`/ePCR/${epcrID}`, {
      'incident.healthSafetyConcernManagerReview': {
        done: true,
        by: user._id,
        notes: managerNotes,
        date: new Date(),
      },
    }).then((res) => {
      if (res.status === 200) {
        setRecord((prev) => ({
          ...prev,
          incident: {
            ...prev.incident,
            healthSafetyConcernManagerReview: {
              done: true,
              by: {
                firstName: user.firstName,
                lastName: user.lastName,
              },
              notes: managerNotes,
              date: new Date(),
            },
          },
        }))
        setOpenReviewPanel(false)
        setToast({ message: 'H&S Incident Review Completed' })
      } else {
        setToast({
          message: 'Unable to update Record. Please try again later.',
        })
      }
    })
  }

  const handleHideShow = () => {
    const newStatus = incident.healthSafetyConcernHiddenFromOrganiser
      ? false
      : true
    API.put(`/ePCR/${epcrID}`, {
      'incident.healthSafetyConcernHiddenFromOrganiser': newStatus,
    }).then((res) => {
      if (res.status === 200) {
        setToast({
          message: newStatus
            ? 'Incident hidden from Event Organiser'
            : 'Incident shared with Event Organiser',
        })
        setRecord((prev) => ({
          ...prev,
          incident: {
            ...prev.incident,
            healthSafetyConcernHiddenFromOrganiser: newStatus,
          },
        }))
      }
    })
  }
  return (
    <DetailsBox
      title="Health & Safety Concern"
      buttonRight={
        setRecord &&
        !incident.healthSafetyConcernManagerReview &&
        setRecord && (
          <Button
            variant="contained"
            color="anPurple"
            size="small"
            onClick={() => setOpenReviewPanel(true)}
          >
            Review
          </Button>
        )
      }
    >
      <Details incident={incident} />
      {setRecord && (
        <>
          <Typography variant="title3">Manager Review</Typography>
          {incident.healthSafetyConcernManagerReview && (
            <>
              <DetailRow
                label="Notes"
                value={incident?.healthSafetyConcernManagerReview?.notes}
              />
              <DetailRow
                label="Reviewed By"
                value={
                  incident?.healthSafetyConcernManagerReview?.by?.firstName +
                  ' ' +
                  incident?.healthSafetyConcernManagerReview?.by?.lastName
                }
              />
              <DetailRow
                label="Date"
                value={moment(
                  incident?.healthSafetyConcernManagerReview?.date,
                ).format('Do MMM YYYY')}
              />
            </>
          )}
        </>
      )}
      {setRecord && (
        <>
          <Alert
            severity={isHidden ? 'info' : 'warning'}
            action={
              <Button variant="outlined" onClick={handleHideShow}>
                {isHidden ? 'Show' : 'Hide'}
              </Button>
            }
          >{`This concern is ${
            isHidden ? 'not ' : ''
          }visible to the Event Organiser on their dashboard ${
            isDraft ? '(when ePCR has been submitted)' : ''
          }`}</Alert>
          <BigModal
            open={openReviewPanel}
            onClose={() => setOpenReviewPanel(false)}
          >
            <Stack gap={1}>
              <Typography variant="title3">Review H&S Incident</Typography>
              <Details incident={incident} />
              <TextField
                value={managerNotes}
                onChange={(e) => setManagerNotes(e.target.value)}
                label="Manager Notes"
                minRows={2}
                multiline
                fullWidth
              />
              <Button
                onClick={handleSubmission}
                disabled={!managerNotes}
                color="success"
                variant="contained"
              >
                Submit Review
              </Button>
            </Stack>
          </BigModal>
        </>
      )}
    </DetailsBox>
  )
}

export default HSIncidentModule
